import { render, staticRenderFns } from "./serviceDetails.vue?vue&type=template&id=524f7b62&"
import script from "./serviceDetails.vue?vue&type=script&lang=js&"
export * from "./serviceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports